import { FieldName } from 'stores/local/shared/lot/FiltersStore';

export const ROUTES = {
  root: {
    path: '/',
    create: () => '/',
  },
  login: {
    path: '/login',
    create: () => '/login',
  },
  registration: {
    path: '/registration',
    create: () => '/registration',
    setPassword: {
      path: '/registration/set_password',
      create: () => '/registration/set_password',
    },
  },
  recovery: {
    path: '/recovery',
    create: () => '/recovery',
    setPassword: {
      path: '/recovery/set_password',
      create: () => '/recovery/set_password',
    },
  },
  lk: {
    path: '/lk',
    create: () => '/lk',
    profile: {
      path: '/lk/profile',
      create: () => '/lk/profile',
    },
    employees: {
      path: '/lk/employees',
      create: () => '/lk/employees',
    },
    clients: {
      path: '/lk/clients',
      create: () => '/lk/clients',
      detail: {
        path: '/lk/clients/:id',
        create: (id: number) => `/lk/clients/${id}`,
      },
    },
    leads: {
      path: '/lk/leads',
      create: () => '/lk/leads',
      detail: {
        path: '/lk/leads/:id',
        create: (id: number) => `/lk/leads/${id}`,
      },
    },
    projects: {
      path: '/lk/projects',
      create: () => '/lk/projects',
      detail: {
        path: '/lk/projects/:slug',
        create: (slug: string) => `/lk/projects/${slug}`,
      },
    },
    lots: {
      path: '/lk/lot',
      create: () => '/lk/lot',
      createDetail: (projectId: number) => `/lk/lot?${FieldName.projects}=${projectId}`,
      detail: {
        path: '/lk/lot/:id',
        create: (id: number) => `/lk/lot/${id}`,
      },
      filters: {
        path: '/lk/lot/filters',
      },
    },
    meetings: {
      path: '/lk/meetings',
      create: () => '/lk/meetings',
    },
    about: {
      path: '/lk/about',
      create: () => '/lk/about',
    },
    documents: {
      path: '/lk/documents',
      create: () => '/lk/documents',
    },
  },
} as const;
